import React from 'react';

export const BookingTextDescription = (props) => (
  <div className="booking-form--text_description color-white marginBtm20">
    <h1 className='paddingTop5 paddingBottom5 color-white'>{props.bigHeading}</h1>
    <span>{props.subHeading}</span>
  </div>
);